/**
 * FLUXAIM — storefront enhancements.
 * Dependency-free so it can run before the theme bundle hydrates.
 */

(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /** Reveal elements as they enter the viewport. */
  const observeReveals = (root = document) => {
    const targets = root.querySelectorAll('.fx-reveal:not([data-fx-observed])');
    if (!targets.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      targets.forEach((el) => {
        el.dataset.fxObserved = 'true';
        el.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    targets.forEach((el) => {
      el.dataset.fxObserved = 'true';
      observer.observe(el);
    });
  };

  const init = (root) => observeReveals(root);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  // Re-run when the theme editor swaps a section in.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
